import { render, staticRenderFns } from "./Renegociacao.vue?vue&type=template&id=27d94f83"
import script from "./Renegociacao.vue?vue&type=script&lang=js"
export * from "./Renegociacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports